// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { HistoryFeedInfoFragmentDoc } from '../../../queries/fragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type EstimateHistoryQueryVariables = Types.Exact<{
  estimateId: Types.Scalars['ID']['input'];
}>;


export type EstimateHistoryQuery = { __typename?: 'Query', projectEstimate: { __typename?: 'Estimate', id: string, history: Array<{ __typename?: 'History', avatar: string, title: string, subtitle?: string | null | undefined, recordedAt: Types.Scalars['DateTime']['input'], userName?: string | null | undefined }> } };


export const EstimateHistoryDocument = gql`
    query EstimateHistory($estimateId: ID!) {
  projectEstimate(id: $estimateId) {
    id
    history {
      ...HistoryFeedInfo
    }
  }
}
    ${HistoryFeedInfoFragmentDoc}`;

/**
 * __useEstimateHistoryQuery__
 *
 * To run a query within a React component, call `useEstimateHistoryQuery` and pass it any options that fit your needs.
 * When your component renders, `useEstimateHistoryQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEstimateHistoryQuery({
 *   variables: {
 *      estimateId: // value for 'estimateId'
 *   },
 * });
 */
export function useEstimateHistoryQuery(baseOptions: ApolloReactHooks.QueryHookOptions<EstimateHistoryQuery, EstimateHistoryQueryVariables> & ({ variables: EstimateHistoryQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<EstimateHistoryQuery, EstimateHistoryQueryVariables>(EstimateHistoryDocument, options);
      }
export function useEstimateHistoryLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<EstimateHistoryQuery, EstimateHistoryQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<EstimateHistoryQuery, EstimateHistoryQueryVariables>(EstimateHistoryDocument, options);
        }
export function useEstimateHistorySuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<EstimateHistoryQuery, EstimateHistoryQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<EstimateHistoryQuery, EstimateHistoryQueryVariables>(EstimateHistoryDocument, options);
        }
export type EstimateHistoryQueryHookResult = ReturnType<typeof useEstimateHistoryQuery>;
export type EstimateHistoryLazyQueryHookResult = ReturnType<typeof useEstimateHistoryLazyQuery>;
export type EstimateHistorySuspenseQueryHookResult = ReturnType<typeof useEstimateHistorySuspenseQuery>;
export type EstimateHistoryQueryResult = Apollo.QueryResult<EstimateHistoryQuery, EstimateHistoryQueryVariables>;